import { createAction, props } from '@ngrx/store';
import { PublicAccountSubmission } from 'src/app/modules/shared/model/publicAccountSubmission.model';

export const loadPublicUserAccounts = createAction(
  '[PublicUserAccount] Load PublicUserAccounts',
  props<{PublicUserAccount: PublicAccountSubmission}>()
);

export const loadPublicUserAccountsSuccess = createAction(
  '[PublicUserAccount] Load PublicUserAccounts Success',
  props<{ data: any }>()
);

export const loadPublicUserAccountsFailure = createAction(
  '[PublicUserAccount] Load PublicUserAccounts Failure',
  props<{ error: any }>()
);


export const addPublicUserAccounts = createAction(
  '[PublicUserAccount] Add PublicUserAccounts',
  props<{PublicUserAccount: PublicAccountSubmission}>()
);

export const addPublicUserAccountsSuccess = createAction(
  '[PublicUserAccount] Add PublicUserAccounts Success',
  props<{ data: any }>()
);

export const addPublicUserAccountsFailure = createAction(
  '[PublicUserAccount] Add PublicUserAccounts Failure',
  props<{ error: any }>()
);
